import { ActiveControls } from '../../../models/project.model';
import { BehaviorSubject } from 'rxjs';

export type ActiveControlsKeys =
  | 'map'
  | 'report'
  | 'bimLock'
  | 'floor'
  | 'points'
  | 'showHideObservations'
  | 'observation'
  | 'split'
  | 'splitBim'
  | 'measure'
  | 'lockScreen'
  | 'menu'
  | 'autoTour'
  | 'imageSettings'
  | 'fullScreen';

export class ActiveControlsClass implements ActiveControls {
  private _activeControlsChanges = new BehaviorSubject<{
    key: ActiveControlsKeys;
    val: boolean;
  }>({
    key: null,
    val: null,
  });
  public readonly activeControlsChanges$ = this._activeControlsChanges.asObservable();

  constructor(defaultValue?: ActiveControls) {
    if (defaultValue) {
      this.set(defaultValue);
    }
  }

  private _map: boolean = false;

  get map(): boolean {
    return this._map;
  }

  set map(val) {
    this._map = val;
    this._activeControlsChanges.next({ key: 'map', val: val });
  }

  private _report: boolean = false;

  get report(): boolean {
    return this._report;
  }

  set report(val) {
    this._report = val;
    this._activeControlsChanges.next({ key: 'report', val: val });
  }

  private _floor: boolean = false;

  get floor(): boolean {
    return this._floor;
  }

  set floor(val) {
    this._floor = val;
    this._activeControlsChanges.next({ key: 'floor', val: val });
  }

  private _points: boolean = false;

  get points(): boolean {
    return this._points;
  }

  set points(val) {
    this._points = val;
    this._activeControlsChanges.next({ key: 'points', val: val });
  }

  private _showHideObservations: boolean = true;

  get showHideObservations(): boolean {
    return this._showHideObservations;
  }

  set showHideObservations(val) {
    this._showHideObservations = val;
    this._activeControlsChanges.next({ key: 'showHideObservations', val: val });
  }

  private _observation: boolean = false;

  get observation(): boolean {
    return this._observation;
  }

  set observation(val) {
    this._observation = val;
    this._activeControlsChanges.next({ key: 'observation', val: val });
  }

  private _split: boolean = false;

  get split(): boolean {
    return this._split;
  }

  set split(val) {
    this._split = val;
    this._activeControlsChanges.next({ key: 'split', val: val });
  }

  private _measure: boolean = false;

  get measure(): boolean {
    return this._measure;
  }

  set measure(val) {
    this._measure = val;
    this._activeControlsChanges.next({ key: 'measure', val: val });
  }

  private _splitBim: boolean = false;

  get splitBim(): boolean {
    return this._splitBim;
  }

  set splitBim(val) {
    this._splitBim = val;
    this._activeControlsChanges.next({ key: 'splitBim', val: val });
  }

  private _pointCloud: boolean = false;

  get pointCloud(): boolean {
    return this._pointCloud;
  }

  set pointCloud(val) {
    this._pointCloud = val;
    // this._activeControlsChanges.next({ key: 'bimLock', val: val });
  }

  private _lockScreen: boolean = true;

  get lockScreen(): boolean {
    return this._lockScreen;
  }

  set lockScreen(val) {
    this._lockScreen = val;
    this._activeControlsChanges.next({ key: 'lockScreen', val: val });
  }

  private _bimLock: boolean = true;

  get bimLock(): boolean {
    return this._bimLock;
  }

  set bimLock(val) {
    this._bimLock = val;
    this._activeControlsChanges.next({ key: 'bimLock', val: val });
  }

  private _menu: boolean = true;

  get menu(): boolean {
    return this._menu;
  }

  set menu(val) {
    this._menu = val;
    this._activeControlsChanges.next({ key: 'menu', val: val });
  }

  private _autoTour: boolean = false;

  get autoTour(): boolean {
    return this._autoTour;
  }

  set autoTour(val) {
    this._autoTour = val;
    this._activeControlsChanges.next({ key: 'autoTour', val: val });
  }

  private _fullScreen: boolean = false;

  get fullScreen(): boolean {
    return this._fullScreen;
  }

  set fullScreen(val) {
    this._fullScreen = val;
    this._activeControlsChanges.next({ key: 'fullScreen', val: val });
  }

  private _imageSettings: boolean = false;

  get imageSettings(): boolean {
    return this._imageSettings;
  }

  set imageSettings(val) {
    this._imageSettings = val;
    this._activeControlsChanges.next({ key: 'imageSettings', val: val });
  }

  set(defaultValue: ActiveControls): void {
    this._map = defaultValue.map;
    this._report = defaultValue.report;
    this._floor = defaultValue.floor;
    this._points = defaultValue.points;
    this._observation = defaultValue.observation;
    this._split = defaultValue.split;
    this._splitBim = defaultValue.splitBim;
    this._lockScreen = defaultValue.lockScreen;
    this._measure = defaultValue.measure;
    this._menu = defaultValue.menu;
    this._autoTour = defaultValue.autoTour;
    this._fullScreen = defaultValue.fullScreen;
    this._imageSettings = defaultValue.imageSettings;
  }
}
